import Header from "../../../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box, Button, MenuItem } from "@mui/material"
import CustomTooltip from "../../../../components/ToolTip"

import BackIcon from "../../../../components/BackIcon"
import Select from "@mui/material/Select"

import { useLocation, useNavigate } from "react-router-dom"
import CustomTextFieldReadable from "../../../../components/CustomTextFieldReadable"
import CustomBackdrop from "../../../../components/CustomBackdrop"
import { useEffect, useState } from "react"
import { useMutation, useQuery } from "@tanstack/react-query"
import fetchwrapper from "../../../../services/interceptors/fetchwrapper"
import normalFormatDate from "../../../utils/date/DDMMYYYFormatDate"
import normalFormatHour from "../../../utils/date/HHMMSSFormatHour"

import GrabarIcon from "../../../../assets/iconos/Grabar.ico"
import DatagridEgresoDetalle from "../../components/DataGridEgresoDetallle"

const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})

const ContainerDetalle = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateRows: "auto auto auto",
  gridTemplateAreas: `
        "IEgreso IEgreso IEgreso IEgreso IFecha IFecha IFecha IFecha ITransaccion ITransaccion ITransaccion ITransaccion "
        "IDetalle IDetalle IDetalle IDetalle IDetalle IDetalle IDetalle IDetalle IDetalle IDetalle IDetalle IDetalle"
        "IIngreso IIngreso IIngreso IIngreso IIngreso IIngreso IPicking IPicking IPicking IPicking IPicking IPicking"
        
      `,
  gap: "8px",
  alignItems: "center",
}))
const IIngreso = styled(Box)({
  gridArea: "IIngreso",
})

const IPicking = styled(Box)({
  gridArea: "IPicking",
})
const IEgreso = styled(Box)({
  gridArea: "IEgreso",
})

const IFecha = styled(Box)({
  gridArea: "IFecha",
})

const ITransaccion = styled(Box)({
  gridArea: "ITransaccion",
})
const IDetalle = styled(Box)({
  gridArea: "IDetalle",
})

const EgresoPickingVer = () => {
  const location = useLocation()
  const datos = location.state
  const navigate = useNavigate()
  const egresoCurrent = datos.tranumero
  const fechaCurrent = datos.trafecha
  const descripcionCurrent = datos.tradescripcion
  const transaccionCurrent = datos.tradescri
  const ingresoCurrent = datos.pctacodigo
  const pickingCurrent = datos.ordnumero
  console.log("row enviado", location)
  console.log("codigo", egresoCurrent)
  const {
    data: fetchedDetalleEgreso = [],
    isError: isLoadingDetalleEgresoError,
    isFetching: isFetchingDetalleEgreso,
    isLoading: isLoadingDetalleEgreso,
    refetch: refetchDetalleEgreso,
  } = useGetDetalleEgresos()

  function useGetDetalleEgresos() {
    return useQuery({
      queryKey: ["fetchedDetalleEgreso"],
      queryFn: async () => {
        const options = {
          method: "POST",
          body: JSON.stringify({
            tranumero: egresoCurrent,
          }),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        console.log("datos enviados al request a ntes de la llamada", options.body)
        let response = await fetchwrapper(`/EgresoPicking/getDetalleEgresoPicking`, options)
        response = await response.json()
        console.log("datos enviados al request", options.body)
        console.log("datos devueltos de la api", response.data)
        return response.data
      },
      refetchOnWindowFocus: false,
      enabled: !!egresoCurrent,
    })
  }

  useEffect(() => {
    refetchDetalleEgreso()
  }, [location?.state?.tranumero])

  const handleSaving = () => {}
  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "16px", padding: "5px" }}>
            <CustomTooltip title={"Ejecutar"}>
              <Button onClick={handleSaving}>
                <img src={GrabarIcon} alt="Guardar" style={{ width: "40px" }} />
              </Button>
            </CustomTooltip>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Egreso por Picking</b>
        </div>
        <Box className={StyledRoot}>
          <ContainerDetalle>
            <IEgreso>
              <CustomTextFieldReadable label="Egreso" value={egresoCurrent} />
            </IEgreso>
            <IFecha>
              <CustomTextFieldReadable label="Fecha" value={normalFormatDate(fechaCurrent)} />
            </IFecha>
            <ITransaccion>
              <CustomTextFieldReadable label="Transaccion" value={transaccionCurrent} />
            </ITransaccion>
            <IDetalle>
              <CustomTextFieldReadable label="Descripcion" value={descripcionCurrent} />
            </IDetalle>
            <IIngreso>
              <CustomTextFieldReadable label="Ingreso" value={ingresoCurrent} />
            </IIngreso>
            <IPicking>
              <CustomTextFieldReadable label="Picking" value={pickingCurrent} />
            </IPicking>
          </ContainerDetalle>
          <br />
          <br />
          <DatagridEgresoDetalle
            fetchedInfo={fetchedDetalleEgreso}
            isLoadingInfoError={isLoadingDetalleEgresoError}
            isLoadingInfo={isLoadingDetalleEgreso}
            isFetchingInfo={isFetchingDetalleEgreso}
            columnsTable={[
              {
                accessorKey: "sgapicking",
                header: "Factura/Solicitud",
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "clipicking",
                header: "Código Cliente",
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "artcodigo",
                header: "Código Articulo",
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "artdescri",
                header: "Descripcion",
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },

              {
                accessorKey: "lotes",
                header: "Lotes",
                size: 150,
                Cell: ({ cell }) => {
                  // Extraemos el valor de la celda, que es un array de lotes
                  const lotes = cell.getValue()

                  // Si `lotes` es un array, lo mapeamos para generar las opciones
                  return (
                    <Select defaultValue="" fullWidth>
                      {lotes.map((lote, index) => (
                        <MenuItem key={index} value={lote.artlote}>
                          {`Lote: ${lote.artlote} | Cantidad: ${lote.artcantlote}`}
                        </MenuItem>
                      ))}
                    </Select>
                  )
                },
              },

              {
                accessorKey: "tracantidad",
                header: "Cantidad solicitada",
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "sgacansolfac",
                header: "Cantidad Picking",
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
            ]}
          />
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default EgresoPickingVer
